<template>
  <div
    class="bg-white border border-surface-200 rounded-2xl overflow-hidden w-full"
    :class="pad ? 'px-4 py-1' : ''"
  >
    <slot />
  </div>
</template>

<script setup lang="ts">
withDefaults(defineProps<{ pad?: boolean }>(), { pad: true });
</script>
